import { useState } from "react";
import { EWithdrawalStep } from "src/types";
import { CreateSessionResponse, Bank, ToggleSwitch } from "src/api";

export interface WithdrawalState {
  // Amount state
  amount: string;
  amountTouched: boolean;

  // Step state
  currentStep: EWithdrawalStep;
  isLoading: boolean;
  error: string | null;

  // Session and bank state
  sessionData: CreateSessionResponse | null;
  banksList: Bank[];
  selectedBank: Bank | null;
  accountNumber: string;

  // MFA state
  mfaCode: string;

  // RTC (Real-Time Clearing) state
  isRtcEnabled: ToggleSwitch | null;
}

export const useWithdrawalState = () => {
  // Amount state
  const [amount, setAmount] = useState<string>("");

  // Step state
  const [currentStep, setCurrentStep] = useState<EWithdrawalStep>(EWithdrawalStep.AmountInput);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Session and bank state
  const [sessionData, setSessionData] = useState<CreateSessionResponse | null>(null);
  const [banksList, setBanksList] = useState<Bank[]>([]);
  const [selectedBank, setSelectedBank] = useState<Bank | null>(null);
  const [accountNumber, setAccountNumber] = useState<string>("");

  // MFA state
  const [mfaCode, setMfaCode] = useState<string>("");

  // RTC state
  const [isRtcEnabled, setIsRtcEnabled] = useState<ToggleSwitch | null>(null);

  return {
    // Amount state
    amount,
    setAmount,

    // Step state
    currentStep,
    setCurrentStep,
    isLoading,
    setIsLoading,
    error,
    setError,

    // Session and bank state
    sessionData,
    setSessionData,
    banksList,
    setBanksList,
    selectedBank,
    setSelectedBank,
    accountNumber,
    setAccountNumber,

    // MFA state
    mfaCode,
    setMfaCode,

    // RTC state
    isRtcEnabled,
    setIsRtcEnabled,
  };
};
